import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from "@mui/material";
import { AxiosError, AxiosRequestConfig } from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import { FormEvent, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { APIS, STUDENT_APIS } from "../../../modules/common/api/apis";
import { deleteOperation, getAxiosHeaders, getStudentsBy, patch, post } from "../../../modules/common/shared/AxiosAPI";
import { GradeSectionComponent } from "../../../modules/common/shared/GradeSectionComponent";
import { STUDENT_MESSAGES } from "../../../modules/common/shared/messages";
import { OperationSucessDialog } from "../../../modules/common/shared/OperationSucessDialog";
import { printStudentAdmissionForm } from "../../../modules/common/shared/StudentAPI";
import { ActionType, Student, STUDENT_STATUS } from "../../../modules/common/shared/types";
import { getLoginId } from "../../../modules/common/user/UserService";
import { ComponentName } from "../../../modules/common/shared/Constants";
import { useStudents } from "../hooks/useStudents";
import { toolbarButtonSx, toolbarFieldsSx } from "../../../components/common/toolbarStyles";

export const StudentsList = () => {
  const navigate = useNavigate();

  const [grade, setGrade] = useState("");
  const [section, setSection] = useState("");
  const [status, setStatus] = useState("ACTIVE");

  const [modifyingStudent, setModifyingStudent] = useState<Student>();
  const [modifyModalShow, setModifyModalShow] = useState(false);
  const [modifyModalMessageHeading, setModifyModalMessageHeading] = useState("");
  const [studentsLoaded, setStudentsLoaded] = useState<boolean>();
  const [modifyStudentConfirmMessage1, setModifyStudentConfirmMessage1] = useState<string>();
  const [showStudentActivatedModal, setShowStudentActivatedModal] = useState<boolean>(false);
  const [deleteModalShow, setDeleteModalShow] = useState<boolean>(false);
  const [deleteStudentMessage, setDeleteStudentMessage] = useState<string>(undefined);

  //MUI
  const [activateDialogState, setActivateDialogState] = useState(false);
  const [successDialogStatus, setSuccessDialogStatus] = useState(false);
  const [successDialogMessage, setSuccessDialogMessage] = useState<string>(undefined);

  useEffect(() => {
    console.log("Loading grades: >>> useEffect");
  }, []);

  const { students, isLoading, actions } = useStudents(grade, section, status);

  useEffect(() => {
    console.log(">>> useEfect [students]");
  }, [students]);

  const activateStudentRequest2 = (student: Student) => {
    setModifyingStudent(student);
    setModifyModalMessageHeading("Activating " + student.name);
    setModifyStudentConfirmMessage1(
      STUDENT_MESSAGES.ACTIVATE_PART1_V2.replace("var_student_name", student.name).replace("var_grade_name", student.gradeName)
    );
    setActivateDialogState(true);
  };

  const deActivateStudentRequest = (editingStudent: Student) => {
    const url = STUDENT_APIS.DEACTIVATE_STUDENT;
    let headers = getAxiosHeaders();
    headers.set("admissionNo", editingStudent.admissionNo);
    patch(url, headers, null)
      .then((res) => {
        setSuccessDialogMessage(res.data);
        setSuccessDialogStatus(true);
        if (res.status === 200) {
          actions.reload();
        }
      })
      .catch((err: AxiosError) => {
        alert(err.message);
      });
  };

  const activateStudent = async () => {
    setModifyModalShow(false);
    setActivateDialogState(false);
    if (modifyingStudent === undefined) alert("Please contact admin");
    try {
      const url = APIS.ACTIVATE_STUDENT;
      let headers = getAxiosHeaders();
      headers.set("admissionNo", modifyingStudent.admissionNo);
      post(url, headers, null)
        .then((res) => {
          if (res.status === 200) {
            modifyingStudent.active = true;
            actions.reload();
            setSuccessDialogMessage("Student activated");
            setSuccessDialogStatus(true);
          }
        })
        .catch((err) => alert(err));
    } catch (e) {
      console.log(e);
    }
  };

  const fetchStudentsV2 = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    actions.reload();
  };

  const editStudent = (student: Student) => {
    console.log(">>> editStudent");
    console.log(student);
    navigate(`/app/students/${student.externalId}`, {
      state: {
        studentObj: student,
        admissionNo: student.admissionNo,
        operation: ActionType.UPDATE,
        requestFrom: getLoginId(),
        instructions:
          "If you change a student's grade, new fee dues will be generated based on the new grade, while the old fee dues will remain unchanged.",
      },
    });
  };
  const deleteRequest = (student: Student) => {
    console.log(">>> deleteRequest");
    setModifyingStudent(student);
    setDeleteModalShow(true);
    setDeleteStudentMessage(
      "Do you really want to delete " + student.name + " Guardian Name: " + student.guardian.name + " admission No: " + student.admissionNo
    );
  };

  const deleteStudent = () => {
    setDeleteModalShow(false);
    let cHeaders = getAxiosHeaders();
    cHeaders.set("admissionNo", modifyingStudent.admissionNo);
    let config: AxiosRequestConfig = { headers: cHeaders };
    deleteOperation(STUDENT_APIS.BY_ADMISSION_NO, config)
      .then((res) => {
        if (res.status === 200) {
          actions.reload();
          setSuccessDialogMessage("Student deleted!");
          setSuccessDialogStatus(true);
        } else {
          alert("Error: " + res.status + " Message: " + res.statusText);
        }
      })
      .catch((err: AxiosError) => alert(err.response?.data));
  };

  const printAdmissionForm = (admissionNo: string) => {
    printStudentAdmissionForm(admissionNo);
  };
  const sharedIconStyle = {
    padding: "1px",
    fontSize: "1.5rem",
    color: "primary.main",
  };
  return (
    <>
      <>
        {/* Top bar: title | filters + Get (outlined, part of the filter) | Add (the page's main action) */}
        <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" sx={{ borderBottom: 1, borderColor: "divider", pb: 1, mt: 2, mr: 2, mb: 2 }}>
          <Typography variant="h6" fontWeight={600}>
            Students
          </Typography>
          <Box flexGrow={1} />
          <Box
            component="form"
            display="flex"
            alignItems="center"
            gap={1}
            onSubmit={fetchStudentsV2}
            sx={toolbarFieldsSx}
          >
            <GradeSectionComponent
              setGrade={(grade) => { setGrade(grade); }}
              setSection={(section) => setSection(section)}
              grade={grade}
              section={section}
              statusListRequired={true}
              statusList={[STUDENT_STATUS.Registered, STUDENT_STATUS.Active, STUDENT_STATUS.Dropped, STUDENT_STATUS.Transferred]}
              status={status}
              setStatus={setStatus}
              viewName={ComponentName.MODIFY_STUDENTS}
              inline
            />
            <Button type="submit" variant="outlined" size="small" sx={toolbarButtonSx}>
              Get
            </Button>
          </Box>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate("/app/students/new")} size="small" sx={{ ...toolbarButtonSx, ml: 2 }}>
            Add
          </Button>
        </Box>
        {!isLoading && students?.length > 0 ? (
          <>
            <TableContainer className="mui-table-container-style">
              <Table size="small" className="mui-table-bordered">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Admission No</TableCell>
                    <TableCell>Guardian Name</TableCell>
                    <TableCell>Guardian Phone No</TableCell>
                    <TableCell>Father Name</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {students?.map((student: Student, index) => (
                    <TableRow key={student.admissionNo}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{student.name}</TableCell>
                      <TableCell>{student.admissionNo}</TableCell>
                      <TableCell>{student.guardian.name}</TableCell>
                      <TableCell>{student.guardian.mobileNo}</TableCell>
                      <TableCell>{student.father.name}</TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Box sx={{ padding: "0px", display: "flex", gap: 1 }}>
                          <Grid>
                            <Tooltip title="Print Admission Form">
                              <LocalPrintshopIcon
                                onClick={(e) => printAdmissionForm(student.admissionNo)}
                                sx={{
                                  color: student.active ? "grey.400" : "green",
                                  cursor: student.active ? "not-allowed" : "pointer",
                                }}
                              />
                            </Tooltip>
                          </Grid>
                          <Grid>
                            <Tooltip title="Drill Down">
                              <ReadMoreIcon onClick={(e) => editStudent(student)} sx={{ color: "green" }} />
                            </Tooltip>
                          </Grid>
                          <Grid>
                            <Tooltip title="Delete">
                              <DeleteIcon
                                onClick={(e) => deleteRequest(student)}
                                sx={{ color: student.active ? "grey.400" : "red", cursor: student.active ? "not-allowed" : "pointer" }}
                              />
                            </Tooltip>
                          </Grid>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ) : !isLoading && students !== undefined ? (
          // students stays undefined until the first "Get"; an empty result after a search lands here.
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              py: 6,
              mr: 2,
              border: 1,
              borderStyle: "dashed",
              borderColor: "#cbd5e1",
              borderRadius: 3,
              bgcolor: "#ffffff",
              color: "text.secondary",
            }}
          >
            <PersonOffIcon sx={{ fontSize: 40, color: "text.disabled" }} />
            <Typography variant="subtitle1" fontWeight={600}>
              No students found
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              There are no students matching the selected grade, section and status. Try different filters.
            </Typography>
          </Box>
        ) : (
          ""
        )}
      </>
      <div>
        <Modal show={modifyModalShow} onHide={() => setModifyModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{modifyModalMessageHeading}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p>
                <span style={{ fontFamily: "Roboto", fontWeight: "bolder" }}>{modifyStudentConfirmMessage1}</span>{" "}
                <span style={{ color: "rgb(255, 70, 127)", fontWeight: "bold" }}>{STUDENT_MESSAGES.ACTIVATE_PART2}</span>{" "}
                <span style={{ fontFamily: "Roboto", fontWeight: "bolder" }}>{STUDENT_MESSAGES.ACTIVATE_PART3}</span>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => setModifyModalShow(false)}
            >
              No
            </Button>
            <Button
              onClick={activateStudent}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStudentActivatedModal} fullscreen="md-down" onHide={() => setShowStudentActivatedModal(false)}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <p className="user-positive-message">Student Activated.</p>
          </Modal.Body>
        </Modal>

        {/* Student delete confirmation dialog start */}
        <Dialog open={deleteModalShow} onClose={() => setDeleteModalShow(false)}>
          <DialogTitle>Delete Student</DialogTitle>
          <DialogContent sx={{ paddingBottom: 0 }}>
            <DialogContentText>
              <Typography variant="subtitle1" sx={{ color: "red" }}>
                {deleteStudentMessage}
              </Typography>
            </DialogContentText>
            <DialogActions>
              <Button size="small" onClick={() => setDeleteModalShow(false)}>
                Cancel
              </Button>
              <Button size="small" type="button" onClick={deleteStudent}>
                Proceed
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
        {/* Student delete confirmation dialog End */}

        {/* Student activation option dialog start */}
        <Dialog
          open={activateDialogState}
          onClose={() => {
            setActivateDialogState(false);
          }}
        >
          <DialogTitle>{modifyModalMessageHeading}</DialogTitle>
          <DialogContent sx={{ paddingBottom: 0 }}>
            <DialogContentText>
              <Box>
                <Grid>
                  <Typography variant="subtitle1">{modifyStudentConfirmMessage1}</Typography>
                </Grid>
                <Grid>
                  <Typography variant="subtitle1" sx={{ color: "red" }}>
                    {STUDENT_MESSAGES.ACTIVATE_PART2}
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="subtitle1">{STUDENT_MESSAGES.ACTIVATE_PART3}</Typography>
                </Grid>
              </Box>
            </DialogContentText>

            <DialogActions>
              <Button
                size="small"
                onClick={() => {
                  setActivateDialogState(false);
                }}
              >
                Cancel
              </Button>
              <Button size="small" type="button" onClick={activateStudent}>
                Proceed
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
        {/* Student activation option dialog End */}

        <OperationSucessDialog open={successDialogStatus} onClose={() => setSuccessDialogStatus(false)} message={successDialogMessage} />
      </div>
    </>
  );
};
